import { AudioFilled, AudioOutlined } from "@ant-design/icons";
import { ReactElement } from "react";
import styled from "styled-components";
import IconBox from "./IconBox";

export interface AnimatedAudioIconProps extends React.HTMLAttributes<HTMLDivElement> {
  isAgentSpeaking: boolean;
}

export default function AnimatedAudioIcon({ isAgentSpeaking, ...divProps }: AnimatedAudioIconProps): ReactElement {
  return (
    <AnimatedAudioIconBox {...divProps}>
      <IconBox $colorTokenKey="colorTextSecondary">
        <AudioOutlined />
      </IconBox>
      <AbsoluteIconBox $colorTokenKey="colorPrimary">
        <AnimatedAudioFilled $showAnimation={isAgentSpeaking} />
      </AbsoluteIconBox>
    </AnimatedAudioIconBox>
  );
}

const AnimatedAudioIconBox = styled.div`
  position: relative;
`;

const AbsoluteIconBox = styled(IconBox)`
  position: absolute;
  top: 0;
  left: 0;
`;

const AnimatedAudioFilled = styled(AudioFilled)<{ $showAnimation: boolean }>`
  opacity: 0;

  @keyframes AnimatedIconBox-animate {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.67;
    }
    100% {
      opacity: 0;
    }
  }

  animation: ${p => p.$showAnimation ? "AnimatedIconBox-animate" : undefined} 1s ${p => p.theme.motionEaseInOut};
  animation-fill-mode: both;
  animation-iteration-count: infinite;
`;
